import { createRESTConn } from "../../../Common";
import { ConnectionNames } from "../../../Contracts";
import { PlayerRequestFormatter } from "../PlayerRequestFormatter";
import { PlayerResponseFormatter } from "../PlayerResponseFormatter";
export function createPlayerDataConnection() {
    return createRESTConn({
        name: ConnectionNames.player,
        handlers: {
            requestFormatter: PlayerRequestFormatter,
            responseFormatter: PlayerResponseFormatter
        }
    });
}
//# sourceMappingURL=CreatePlayerDataConnection.js.map